import { render, staticRenderFns } from "./ButtonArrow.vue?vue&type=template&id=e137ccf6&"
import script from "./ButtonArrow.vue?vue&type=script&lang=js&"
export * from "./ButtonArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@0.28.11_lodash@4.17.21_webpack@3.12.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/reused-components/button-arrow/ButtonArrow.vue
// module id = 161
// module chunks = 57